/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type PortfolioTypes = "CART" | "FOLDER" | "HEART" | "PROCUREMENT" | "PROJECT" | "%future added value";
export type PortfoliosAction = "ADD" | "EDIT" | "REMOVE" | "REORDER" | "%future added value";
export type PrivacyType = "PRIVATE" | "PUBLIC" | "SHAREABLE" | "%future added value";
export type ModifyPortfoliosInput = {
    readonly action: PortfoliosAction;
    readonly description?: string | null;
    readonly endPortfolioId?: string | null;
    readonly itemsIds?: ReadonlyArray<string | null> | null;
    readonly name?: string | null;
    readonly note?: string | null;
    readonly portfolioIds?: ReadonlyArray<string | null> | null;
    readonly portfoliosType: PortfolioTypes;
    readonly privacyLevel?: PrivacyType | null;
    readonly startPortfolioId?: string | null;
    readonly targetPortfolioId?: string | null;
    readonly userId: string;
    readonly clientMutationId?: string | null;
};
export type ModifyPortfolios_esMutationVariables = {
    readonly input: ModifyPortfoliosInput;
};
export type ModifyPortfolios_esMutationResponse = {
    readonly modifyPortfolios: {
        readonly portfolio: {
            readonly id: string;
            readonly serviceId: string | null;
        } | null;
        readonly portfolios: ReadonlyArray<{
            readonly id: string;
        } | null> | null;
    } | null;
};
export type ModifyPortfolios_esMutation = {
    readonly response: ModifyPortfolios_esMutationResponse;
    readonly variables: ModifyPortfolios_esMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "ModifyPortfoliosInput!",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "modifyPortfolios",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "ModifyPortfoliosPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "portfolio",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfolioV2",
                    "plural": false,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "serviceId",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                },
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "portfolios",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfolioV2",
                    "plural": true,
                    "selections": [
                        (v1 /*: any*/)
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "ModifyPortfolios_esMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v2 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "ModifyPortfolios_esMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v2 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "ModifyPortfolios_esMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/ModifyPortfolios_esMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '0463c0ea7152430cffe365763ae5f0f8';
export default node;
